import React, { Component } from 'react';

class InfoBlock extends Component {

	constructor(props) {
		super(props);

		this._containerStyle = {
			width: this.props.width,
			height: this.props.imageHeight ,
			fontFamily: this.props.fontFamily,
			fontSize: this.props.fontSize,
			display: 'inline-block',
			position: 'relative'
		};

		this._imageStyle = {
			display: 'block',
			width: this.props.imageHeight,
			height: this.props.imageHeight,
			borderTopLeftRadius: this.props.unit * 0.15,
			borderTopRightRadius: this.props.unit * 0.15,
			borderBottomLeftRadius: this.props.unit * 0.15,
			borderBottomRightRadius: this.props.unit * 0.15,
			zIndex: 1,
			overflow: "hidden"
		};

		this._infoBlockStyle = {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			color: this.props.infoColor,
			backgroundColor: this.props.infoBackgroundColor,
			height: this.props.imageHeight,
			borderBottomLeftRadius: this.props.unit * 0.15,
			borderBottomRightRadius: this.props.unit * 0.15,
			width: this.props.width
		}
	}

	render() {
		let float = this.props.floatRight ? "right" : "inherited";
		return(
			<div style={{ ...this._imageStyle, backgroundImage: `url(${this.props.imgsrc})`, backgroundSize:"cover", backgroundPosition:"center", backgroundRepeat:"no-repeat", float: float }}>
				{/* <img style={{ minWidth: this._imageStyle.width, minHeight: this._imageStyle.height, maxWidth: this._imageStyle.width * 1.05, maxHeight: this._imageStyle.height * 1.05 }} src={this.props.imgsrc} alt={name} /> */}
			</div>
		)
		// return (
		// 	<div style={this._containerStyle}>
		// 		<img style={this._imageStyle} src={this.props.imgsrc} alt={name} />
		// 		{/* <div style={this._infoBlockStyle}>
		// 			<span style={{ marginRight: "0.625vh" }}>
		// 				<img alt="Forward" src={"/img/miami/ui/icon-arrow-forward.png"} style={{ display: 'inline-block', textAlign: 'right', width: "1.25vh" }} />
		// 			</span>
		// 		</div> */}
		// 	</div>
		// )
	}
}

module.exports = InfoBlock;



// WEBPACK FOOTER //
// ./src/Components/Theme/Seattle/InfoBlockSeattle.js